import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ComisionBancaria,
  CreateComisionDto,
  UpdateComisionDto,
  ComisionFilterDto,
  PaginationDto,
  ComisionPaginatedResponse,
} from '../interfaces/comision-bancaria';

@Injectable({
  providedIn: 'root',
})
export class ComisionesBancariasService {
  API_URL = environment.apiNest;

  constructor(private http: HttpClient) {}

  findAll(
    filters?: ComisionFilterDto,
    pagination?: PaginationDto,
  ): Promise<ComisionPaginatedResponse> {
    let params = new HttpParams();

    // Filtros
    if (filters?.bancoId) {
      params = params.set('bancoId', filters.bancoId.toString());
    }
    if (filters?.tipoCuenta) {
      params = params.set('tipoCuenta', filters.tipoCuenta);
    }
    if (filters?.tipoOperacion) {
      params = params.set('tipoOperacion', filters.tipoOperacion);
    }

    // Paginación
    if (pagination?.page) {
      params = params.set('page', pagination.page.toString());
    }
    if (pagination?.limit) {
      params = params.set('limit', pagination.limit.toString());
    }
    if (pagination?.sortBy) {
      params = params.set('sortBy', pagination.sortBy);
    }
    if (pagination?.sortOrder) {
      params = params.set('sortOrder', pagination.sortOrder);
    }

    const serviceURL = `${this.API_URL}comisiones-bancarias-control`;
    return firstValueFrom(
      this.http.get<ComisionPaginatedResponse>(serviceURL, { params }),
    );
  }

  findOne(id: number): Promise<ComisionBancaria> {
    const serviceURL = `${this.API_URL}comisiones-bancarias-control/${id}`;
    return firstValueFrom(this.http.get<ComisionBancaria>(serviceURL));
  }

  create(dto: CreateComisionDto): Promise<ComisionBancaria> {
    const serviceURL = `${this.API_URL}comisiones-bancarias-control`;
    return firstValueFrom(this.http.post<ComisionBancaria>(serviceURL, dto));
  }

  update(id: number, dto: UpdateComisionDto): Promise<ComisionBancaria> {
    const serviceURL = `${this.API_URL}comisiones-bancarias-control/${id}`;
    return firstValueFrom(this.http.put<ComisionBancaria>(serviceURL, dto));
  }

  toggle(id: number, activo: boolean): Promise<ComisionBancaria> {
    const serviceURL = `${this.API_URL}comisiones-bancarias-control/${id}/toggle`;
    return firstValueFrom(
      this.http.put<ComisionBancaria>(serviceURL, { activo }),
    );
  }

  getHistorial(
    bancoId: number,
    tipoOperacion: string,
  ): Promise<ComisionBancaria[]> {
    const serviceURL = `${this.API_URL}comisiones-bancarias-control/${bancoId}/${tipoOperacion}/historial`;
    return firstValueFrom(this.http.get<ComisionBancaria[]>(serviceURL));
  }

  calcularComision(
    bancoId: number,
    tipoCuenta: string,
    tipoOperacion: string,
    monto: number,
  ): Promise<any> {
    let params = new HttpParams()
      .set('bancoId', bancoId.toString())
      .set('tipoCuenta', tipoCuenta)
      .set('tipoOperacion', tipoOperacion)
      .set('monto', monto.toString());

    const serviceURL = `${this.API_URL}comisiones-bancarias-control/calcular`;
    return firstValueFrom(this.http.get<any>(serviceURL, { params }));
  }

  getMatriz(codigoPais: string = 'VE'): Promise<any> {
    let params = new HttpParams().set('codigoPais', codigoPais);
    const serviceURL = `${this.API_URL}comisiones-bancarias-control/matriz`;
    return firstValueFrom(this.http.get<any>(serviceURL, { params }));
  }
}
